import { Link } from 'react-router-dom';
import { mangaList } from '@/mocks/manga';
import MangaCard from '@/components/base/MangaCard';

export default function HeroSection() {
  const featuredManga = mangaList.filter(m => m.rating >= 9.5).slice(0, 3);

  return (
    <section className="relative w-full min-h-[520px] md:min-h-[620px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Japanese%20manga%20anime%20style%20illustration%20with%20warm%20vibrant%20colors%2C%20abstract%20comic%20panel%20background%20with%20action%20lines%20and%20speed%20effects%2C%20dramatic%20composition%2C%20artistic%20ink%20wash%20style%20mixed%20with%20modern%20digital%20art%2C%20cinematic%20lighting%2C%20warm%20coral%20and%20golden%20accents%2C%20no%20text&width=1600&height=900&seq=hero-manga-bg&orientation=landscape"
          alt="亲亲漫画背景"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/35 to-black/60"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-12 md:py-20">
        <div className="max-w-screen-2xl mx-auto">
          <div className="flex flex-col lg:flex-row items-start lg:items-center gap-8 lg:gap-16">
            <div className="flex-1 text-center lg:text-left">
              <div className="inline-flex items-center gap-2 bg-accent-500/20 backdrop-blur-sm border border-accent-300/30 px-4 py-1.5 rounded-full mb-5">
                <i className="ri-fire-line text-accent-500 text-sm"></i>
                <span className="text-xs font-medium text-white">每日更新 200+ 话 · 全网热追中</span>
              </div>
              <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading text-white leading-tight mb-4">
                亲亲漫画
              </h1>
              <p className="text-lg md:text-xl text-white/80 mb-6 max-w-xl mx-auto lg:mx-0 leading-relaxed">
                韩漫 · 日漫 · 国漫热门推荐，免费全集下拉式在线漫画大全
              </p>
              <p className="text-sm md:text-base text-white/60 mb-8 max-w-lg mx-auto lg:mx-0">
                按地域精选优质漫画，海量资源每日更新，流畅下拉式阅读体验，让好看的漫画触手可及
              </p>
              <div className="flex flex-col sm:flex-row items-center gap-3 justify-center lg:justify-start">
                <Link
                  to="/category/remen"
                  className="w-full sm:w-auto px-8 py-3 bg-primary-500 hover:bg-primary-600 text-white font-semibold rounded-lg transition-colors duration-200 cursor-pointer whitespace-nowrap text-center"
                >
                  <i className="ri-fire-line mr-2"></i>热门推荐
                </Link>
                <Link
                  to="/category/hanman"
                  className="w-full sm:w-auto px-8 py-3 bg-white/15 hover:bg-white/25 backdrop-blur-sm border border-white/20 text-white font-semibold rounded-lg transition-colors duration-200 cursor-pointer whitespace-nowrap text-center"
                >
                  <i className="ri-heart-line mr-2"></i>韩漫精选
                </Link>
                <Link
                  to="/category/riman"
                  className="w-full sm:w-auto px-8 py-3 bg-white/15 hover:bg-white/25 backdrop-blur-sm border border-white/20 text-white font-semibold rounded-lg transition-colors duration-200 cursor-pointer whitespace-nowrap text-center"
                >
                  <i className="ri-star-line mr-2"></i>日漫经典
                </Link>
              </div>
            </div>

            <div className="hidden lg:grid grid-cols-3 gap-4 w-full lg:w-auto flex-shrink-0">
              {featuredManga.map((manga) => (
                <Link
                  key={manga.id}
                  to={`/manga/${manga.slug}`}
                  className="group w-[140px] cursor-pointer"
                >
                  <div className="relative overflow-hidden rounded-lg aspect-[3/4] mb-2">
                    <img
                      src={manga.coverImage}
                      alt={manga.title}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    />
                    <div className="absolute inset-0 bg-black/30 group-hover:bg-black/10 transition-colors duration-300"></div>
                  </div>
                  <p className="text-sm font-semibold text-white text-center line-clamp-1 group-hover:text-primary-300 transition-colors duration-200">
                    {manga.title}
                  </p>
                  <p className="text-xs text-white/60 text-center mt-0.5">
                    ★ {manga.rating}
                  </p>
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}